import './index.less'




// WEBPACK FOOTER //
// ./src/view/information/index.js